import { render } from "./viewOrder.html?vue&type=template&id=3bd2f343&scoped=true&ts=true&external"
import script from "./ViewOrder.vue?vue&type=script&lang=ts"
export * from "./ViewOrder.vue?vue&type=script&lang=ts"

import "./ViewOrder.vue?vue&type=style&index=0&id=3bd2f343&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd2f343"]])

export default __exports__